/**
 * Phase 3 D-26 — GST split per invoice line.
 * Intra-state (member.state == issuer.state, OR member.state nullish) → CGST + SGST split halves.
 * Inter-state (member.state != issuer.state) → IGST full rate, CGST/SGST = 0.
 */
export interface GstSplit {
  cgst: number;
  sgst: number;
  igst: number;
}

export function deriveGstSplit(
  gstRate: number,
  memberState: string | null | undefined,
  issuerState: string,
): GstSplit {
  if (!memberState || memberState === issuerState) {
    const half = gstRate / 2;
    return { cgst: half, sgst: half, igst: 0 };
  }
  return { cgst: 0, sgst: 0, igst: gstRate };
}
